<template>
    <!-- 手动补开卡信息管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'repairCardList')">
        <div slot="header">
            <a-form :form="form" layout="inline" class="store-one-form">
                <a-form-item label="补开卡手机号">
                    <a-input placeholder="请输入" v-decorator="['phone']" ></a-input>
                </a-form-item>
                <a-form-item label="补开卡时间">
                    <a-range-picker
                        style="width:282px"
                        format="YYYY/MM/DD"
                        v-decorator="['repairTime']"
                    />
                </a-form-item>
                <a-form-item label="操作人">
                    <a-input placeholder="请输入" v-decorator="['operator']" ></a-input>
                </a-form-item>
                <a-form-item label="来源区分">
                    <a-select
                        v-decorator="['isThird']"
                        placeholder="请选择"
                    >
                        <a-select-option
                        v-for="(item) in sourceType"
                        :key="item.id"
                        :value="item.id"
                        >{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="wrap-container-in">
            <a-table :scroll="{x:800}" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record,index) => index">
                <span slot="index" slot-scope="a,row,index">{{index + 1}}</span>
                <span slot="effectiveDate" slot-scope="effectiveDate,row">{{row.validStartTime + '～' + row.validEndTime}}</span>
                <span slot="isThird" slot-scope="a,row">{{['票券赠送', '第三方购买'][Number(row.isThird)]}}</span>
                <span slot="remarkCategoryName" slot-scope="remarkCategoryName">{{remarkCategoryName || "-"}}</span>
                <span slot="remark" slot-scope="remark">{{remark || "-"}}</span>
                <span slot="operator" slot-scope="operator">{{operator || "-"}}</span>
            </a-table>
        </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    const columns = [
    {
        title: "序号",
        key: "index",
        scopedSlots: { customRender: "index" }
    },
    {
        title: "补开卡手机号",
        dataIndex: "phone"
    },
    {
        title: "开卡票券内部标识名称",
        dataIndex: "ticketName",
    },
    {
        title: "开卡票券展示名称",
        dataIndex: "ticketShowName",
    },
    {
        title: "票券有效时间",
        dataIndex: "effectiveDate",
        scopedSlots: { customRender: "effectiveDate" }
    },
    {
        title: "来源区分",
        dataIndex: "isThird",
        scopedSlots: { customRender: "isThird" }
    },
    {
        title: "备注类型",
        dataIndex: "remarkCategoryName",
        scopedSlots: { customRender: "remarkCategoryName" }
    },
    {
        title: "备注",
        dataIndex: "remark",
        scopedSlots: { customRender: "remark" }
    },
    {
        title: "补开卡时间",
        dataIndex: "operateTime"
    },
    {
        title: "操作人",
        dataIndex: "operator",
        scopedSlots: { customRender: "operator" }
    }]
    import moment  from 'moment';
    export default {
        name: "repairCardList",
        components: {},
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                sourceType: [
                    {
                        id: true,
                        name: '第三方购买'
                    },
                    {
                        id: false,
                        name: '票券赠送'
                    },
                ]
            };
        },
        computed: {},
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        methods: {
            moment,
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            handleReset() {
                this.form.resetFields();
                this.getList()
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const repairTime = values['repairTime'] ? values['repairTime'] : []
                    values.startTime = repairTime.length > 0 ? repairTime[0].format('YYYY-MM-DD 00:00:00') : undefined
                    values.endTime = repairTime.length > 0 ? repairTime[1].format('YYYY-MM-DD 23:59:59') : undefined
                    delete values.repairTime
                    this.$api.member
                    .repairTicketList({
                        body: Object.assign(values, 
                        {   
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    })
                    .then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                    });
                });
            },

        },
        mounted() {
            this.getList()
        },
    };
</script>
<style lang="scss">
</style>